import { forwardRef } from 'react'

import {
  ContactListInput,
  type ContactListInputHandle,
  type ContactListInputProps,
} from '@fv/client-components/contact-list-input'

type Props = ContactListInputProps
export const ShipperContactListInput = forwardRef<
  ContactListInputHandle,
  Props
>((props, ref) => {
  return (
    <ContactListInput
      {...props}
      ref={ref}
      portalToRoot
      classNames={{
        root: 'border-b-fv-blue border border-b-2 bg-white pt-0 h-full flex flex-col',
        chipsContainer:
          'flex flex-wrap content-start justify-start overflow-y-auto p-2 flex-1',
        chip: 'flex items-center m-0.5',
        chipLabel: 'bg-fv-beer-light p-1 border-fv-gray border text-sm',
        chipRemove:
          'bg-white flex items-center self-stretch border border-fv-gray border-l-0 p-1 [&_svg]:text-fv-orange hover:[&_svg]:text-fv-gray-dark',
        inputWrapper: 'border-fv-gray border-0 border-t',
        input:
          'flex w-full px-2 py-0.5 m-0 leading-8 outline-hidden placeholder:text-fv-gray-dark placeholder:text-sm',
        popup: 'mt-1 bg-white border shadow-lg z-50',
        list: 'max-h-[200px] overflow-y-auto',
        item: 'px-3 py-2 cursor-pointer hover:bg-gray-100 data-[highlighted]:bg-gray-100',
      }}
    />
  )
})
